var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"CloseButton",on:{"click":_vm.onCloseClick}},[_c('CloseIcon')],1)}
var staticRenderFns = []

export { render, staticRenderFns }